(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 83236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(1047);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ AuthLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_system_logo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69622);
/* harmony import */ var hooks_is_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77963);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44868);
/* harmony import */ var _auth_layout_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65205);
/* harmony import */ var _auth_layout_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_auth_layout_module_css__WEBPACK_IMPORTED_MODULE_6__);







var AuthLayout = function(param) {
    var cta = param.cta, children = param.children;
    var isMobile = (0,hooks_is_mobile__WEBPACK_IMPORTED_MODULE_2__/* .useIsMobile */ .d)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .classNames */ .AK)([
            (_auth_layout_module_css__WEBPACK_IMPORTED_MODULE_6___default().container),
            cta && (_auth_layout_module_css__WEBPACK_IMPORTED_MODULE_6___default().fullHeight)
        ]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_auth_layout_module_css__WEBPACK_IMPORTED_MODULE_6___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        prefetch: false,
                        href: "/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_logo__WEBPACK_IMPORTED_MODULE_1__/* .Logo */ .T, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_auth_layout_module_css__WEBPACK_IMPORTED_MODULE_6___default().children),
                        children: children
                    })
                ]
            }),
            !isMobile && cta
        ]
    });
};


/***/ }),

/***/ 49479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ MachineCTA; },
/* harmony export */   "m": function() { return /* binding */ DreamCTA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44868);
/* harmony import */ var _cta_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14433);
/* harmony import */ var _cta_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_cta_module_css__WEBPACK_IMPORTED_MODULE_2__);



var DreamCTA = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,utils__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .AK)([
            (_cta_module_css__WEBPACK_IMPORTED_MODULE_2___default().cta),
            (_cta_module_css__WEBPACK_IMPORTED_MODULE_2___default().dream)
        ]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_cta_module_css__WEBPACK_IMPORTED_MODULE_2___default().message),
                children: "Land Your Dream Job"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_cta_module_css__WEBPACK_IMPORTED_MODULE_2___default().submessage),
                children: "Ace your interview and land your dream data job in data science, analytics, and machine learning."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_cta_module_css__WEBPACK_IMPORTED_MODULE_2___default().image),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/dream.svg",
                    alt: "background image"
                })
            })
        ]
    });
};
var MachineCTA = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,utils__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .AK)([
            (_cta_module_css__WEBPACK_IMPORTED_MODULE_2___default().cta),
            (_cta_module_css__WEBPACK_IMPORTED_MODULE_2___default().machine)
        ]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_cta_module_css__WEBPACK_IMPORTED_MODULE_2___default().message),
                children: "Crack the Data Science Interview"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_cta_module_css__WEBPACK_IMPORTED_MODULE_2___default().submessage),
                children: "Learn how to solve data science interview questions by practicing questions each week."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_cta_module_css__WEBPACK_IMPORTED_MODULE_2___default().image),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/machine.svg",
                    alt: "background image"
                })
            })
        ]
    });
};


/***/ }),

/***/ 1047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22821);
/* harmony import */ var components_users_auth_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33770);
/* harmony import */ var components_users_cta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49479);
/* harmony import */ var components_users_login__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44506);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);






var LogInPage = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_seo__WEBPACK_IMPORTED_MODULE_1__/* .MetaTags */ .N, {
                title: "Log In"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_users_auth_layout__WEBPACK_IMPORTED_MODULE_2__/* .AuthLayout */ .g, {
                cta: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_users_cta__WEBPACK_IMPORTED_MODULE_3__/* .DreamCTA */ .m, {}),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_users_login__WEBPACK_IMPORTED_MODULE_4__/* .LogIn */ .u, {
                    onSuccess: function(user) {
                        return router.push(router.query.next || user.startURL);
                    }
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (LogInPage);
LogInPage.layoutConfig = {
    hideHeader: true,
    hideAuthBanner: true,
    fullWidth: true,
    hideSaleBanner: true,
    hideMockInterviewsBanner: true
};


/***/ }),

/***/ 65205:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"auth_layout_container__KppuI","fullHeight":"auth_layout_fullHeight__sqIx1","content":"auth_layout_content__lqPGN","children":"auth_layout_children__u7i5j"};

/***/ }),

/***/ 14433:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cta":"cta_cta__cd7rT","dream":"cta_dream__RVraD","machine":"cta_machine__Bh_oh","message":"cta_message__TnuxT","submessage":"cta_submessage__M3GpW","image":"cta_image__e_lyT"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(83236); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);